import React, { type FC, type PropsWithChildren } from 'react';

type WarningProps = {
  /** The color of the ellipsis icon */
  color?: string;
};

const Warning: FC<PropsWithChildren<WarningProps>> = ({ color = 'currentcolor' }) => (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M12.4343 4.76756C12.2424 4.43165 11.758 4.43165 11.5661 4.76756L3.28927 19.252C3.0988 19.5853 3.33948 20.0001 3.7234 20.0001H20.277C20.6609 20.0001 20.9016 19.5853 20.7112 19.252L12.4343 4.76756Z"
      fill={color}
      fillRule="evenodd"
      opacity="0.35"
    />
    <path
      d="M12.7497 17.0001C12.7497 17.4143 12.414 17.7501 11.9997 17.7501C11.5855 17.7501 11.2497 17.4143 11.2497 17.0001C11.2497 16.5858 11.5855 16.2501 11.9997 16.2501C12.414 16.2501 12.7497 16.5858 12.7497 17.0001Z"
      fill={color}
    />
    <path
      d="M11.9997 9.00006C11.5907 9.00006 11.2639 9.3407 11.2809 9.74941L11.4789 14.5005C11.4905 14.7797 11.7203 15.0001 11.9997 15.0001C12.2792 15.0001 12.5089 14.7797 12.5205 14.5005L12.7185 9.74941C12.7355 9.3407 12.4088 9.00006 11.9997 9.00006Z"
      fill={color}
    />
    <path
      clipRule="evenodd"
      d="M10.6974 4.27142C11.2732 3.26369 12.7263 3.2637 13.3021 4.27142L21.5789 18.7559C22.1503 19.7558 21.4283 21.0001 20.2766 21.0001H3.72292C2.57119 21.0001 1.84913 19.7558 2.42055 18.7559L10.6974 4.27142ZM12.4339 4.76756C12.2419 4.43165 11.7576 4.43165 11.5656 4.76756L3.2888 19.252C3.09832 19.5853 3.33901 20.0001 3.72292 20.0001H20.2766C20.6605 20.0001 20.9012 19.5853 20.7107 19.252L12.4339 4.76756Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export default Warning;
